export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_detailing-app-9/artifacts/37jpa7nw_MGW%203D.jpg";

// Crop tightly around the logo subject to avoid the broad gray studio background
// We use object-fit: contain + a CSS filter that drops the bright background to black
// and inverts the black silhouette to white so it sits cleanly on our dark UI.
export const LOGO_DARK_FILTER =
  "invert(1) brightness(1.2) contrast(1.15)";
